export default __webpack_public_path__ + "static/media/banner-1.6433ebb5.png";